export const replaceFileName = (url: string, newFileName: string): string => {
  const splittedUrl = url.split('/')
  splittedUrl.splice(splittedUrl.length - 1, 1, newFileName)
  return splittedUrl.join('/')
}

export const getFirstFrameUrl = (videoUrl: string): string => {
  return replaceFileName(videoUrl, 'firstframe.webp')
}

export const getLastFrameUrl = (videoUrl: string): string => {
  return replaceFileName(videoUrl, 'lastframe.webp')
}

export const getMiddleFrameUrl = (videoUrl: string): string => {
  return replaceFileName(videoUrl, 'middleframe.webp')
}
